import React, { useEffect } from 'react';
import './Legais.css';

function Lgpd() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legais-page">
            <div className="legais-container">
                <div className="legais-header">
                    <h1>Governança e Proteção de Dados (LGPD)</h1>
                    <p>Adequação Completa à Lei Federal nº 13.709/2018</p>
                </div>

                <div className="legais-section">
                    <h2>1. Compromisso do Agroov com a LGPD</h2>
                    <p>A Lei Geral de Proteção de Dados Pessoais (LGPD) estabelece regras claras sobre a coleta, armazenamento e compartilhamento de informações. O Agroov assume o compromisso público de zelar pelo ciclo de vida dos seus dados.</p>
                </div>

                <div className="legais-section">
                    <h2>2. Seus Direitos como Titular de Dados</h2>
                    <p>Nos termos da legislação vigente, você possui total controle sobre suas informações pessoais e pode exercer os seguintes direitos:</p>
                    <ul>
                        <li><strong>Confirmação e Acesso:</strong> Saber se tratamos seus dados e ter acesso a eles de forma simplificada.</li>
                        <li><strong>Correção:</strong> Alterar dados incorretos ou desatualizados em seu painel de controle.</li>
                        <li><strong>Exclusão (Direito ao Esquecimento):</strong> Solicitar a eliminação definitiva do seu cadastro do banco de dados do Agroov.</li>
                    </ul>
                </div>

                <div className="legais-section">
                    <h2>3. Canal de Atendimento da Privacidade</h2>
                    <p>Para exercer seus direitos descritos acima ou esclarecer quaisquer dúvidas operacionais, envie um e-mail documentado anexando cópia de identificação civil para: <strong>agroov2026@gmail.com</strong>.</p>
                </div>
            </div>
        </div>
    );
}

export default Lgpd;
